module.exports = __webpack_public_path__ + "static/img/1-4.6caabf38.jpg";